/*
 * ---------------------------------------------------------------------
 * import modules
 * ---------------------------------------------------------------------
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    Icon,
    IconButton,
    Tooltip,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@material-ui/core";

/*
 * ---------------------------------------------------------------------
 * import components
 * ---------------------------------------------------------------------
 */
import {
    Translate,
    t
} from "src/shared_modules/i18n";

/*
 * ---------------------------------------------------------------------
 * import action
 * ---------------------------------------------------------------------
 */
import {
    showPopover,
    hidePopover,
} from 'src/shared_modules/veu-visitors-core/actions/popovers';

import {
    hidePageGlobal
} from "src/shared_modules/veu-visitors-core/actions/pages";


import './login-button.css';

/*
 * ---------------------------------------------------------------------
 * class LoginButton
 * ---------------------------------------------------------------------
 */
class LoginButton extends React.Component {

    componentDidMount() {
        this.clickLogin = this.clickLogin.bind(this);
    }


    clickLogin() {
        // TODO
        //if( this.props.event.accesslevel !== "public" )
        //    return;

        this.props.hidePageGlobal();

        if( !this.props.popovers.showLogin ){
            if( this.props.popovers.showForgot )
                this.props.hidePopover("Forgot");

            if( this.props.popovers.showRegister )
                this.props.hidePopover("Register");

            this.props.showPopover("Login");
        } else {
            this.props.hidePopover("Login");
        }
        if( this.props.onClick )
            this.props.onClick();
    }

    render() {
        // no plazz convention no login possible
        if( !this.props.event.hasPlazzConvention )
            return (null);

        if( this.props.user.loggedIn )
            return (null);

        //    background: url("/visitor/assets/login.png") no-repeat center;
        let icon={
            backgroundImage: `url("${process.env.PUBLIC_URL}/assets/logout.png")`
        }

        return (<React.Fragment>
                    {!this.props.mobile && <Tooltip title={t("main-nav.login") } >
                        <IconButton aria-label="login" onClick={() => this.clickLogin()}>
                            <Icon className="app-logout-icon rotate180" style={icon} />
                        </IconButton>
                    </Tooltip> }
                    { this.props.mobile && <ListItem key="item-login" button onClick={() => this.clickLogin()} >
                            <ListItemIcon><Icon className="app-logout-icon rotate180" style={icon} /></ListItemIcon>
                            <ListItemText primary={<Translate>main-nav.login</Translate>} />
                        </ListItem> }
            </React.Fragment>);
        }

}
/*
 * ---------------------------------------------------------------------
 * LoginButton prop Types
 * ---------------------------------------------------------------------
 */
LoginButton.propTypes = {
    user : PropTypes.object,
    event : PropTypes.object,
    popovers : PropTypes.object,
};
/*
 * ---------------------------------------------------------------------
 * LoginButton Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        user : state.user,
        event : state.event,
        currentLang : state.system.currentLang,
        popovers: state.popovers,
    };
};

const mapDispatchToProps = {
    showPopover,
    hidePopover,
    hidePageGlobal,
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(LoginButton);
